import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { ScrollToTop } from "./components/ScrollToTop";
import Cart from "./components/Cart";
import { CartProvider } from "./context/CartContext";
import { Home } from "./pages/Home";
import { Products } from "./pages/Products";
import { About } from "./pages/About";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produtos" element={<Products />} />
            <Route path="/conheca" element={<About />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Cart />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
